import { sortByOrderMap } from "utils/sort";

export const BUNDLE_REWARD_ORDER: Record<string, number> = {
	coin: 1,
	volcano: 2,
	wild: 3,
	sc_pack_common: 4,
	sc_pack_uncommon: 4,
	sc_pack_rare: 4,
	sc_pack_epic: 4,
	sc_pack_legendary: 4,
	sc_pack_chameleon: 4,
	paws: 5,
	club_point_boost: 6,
	tribute_doubler: 7,
	booster_streak: 8,
	random: 10
};

export const DEFAULT_REWARD_ORDER = 9;

export const sortBundleRewards = <T extends { id: string }>(
	arr: T[] | readonly T[] | undefined,
	orderMap: Record<string, number> = BUNDLE_REWARD_ORDER,
	defaultOrder = DEFAULT_REWARD_ORDER
) => sortByOrderMap(arr, orderMap, defaultOrder);
